import React from 'react';
import PropTypes from 'prop-types';

import {
  Display,
  Content,
  HardwareButtonWrapper
} from 'containers';

import styles from './RED.scss';

const RED = ({ src }) => [
  <Display key="display">
    <Content>
      <div className={styles.RED}>
        <i className={styles[src]} />
      </div>
    </Content>
  </Display>,
  <HardwareButtonWrapper key="buttons" config={{}} />
];

RED.propTypes = {
  src: PropTypes.string.isRequired
};

export default RED;




// WEBPACK FOOTER //
// ./src/screens/shared/RED/RED.js